import { v4 as uuid } from "uuid";

export const getSessionUuid = (): string => {
  const KEY = "surveyEngineSessionUuid";
  const existingSessionUuid = sessionStorage.getItem(KEY);

  // If there is an existing session UUID, return it
  if (existingSessionUuid) {
    return existingSessionUuid;
  }

  const sessionUuid = uuid();
  sessionStorage.setItem(KEY, sessionUuid); // Save the new UUID to sessionStorage
  return sessionUuid;
};
